(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gn-portfolio-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gn-editorial-gallery')) {
    customElements.define('gn-editorial-gallery', class extends HTMLElement {
      connectedCallback() {
        this.looks = Array.from(this.querySelectorAll('[data-look]'));
        this.position = Math.max(0, this.looks.findIndex((look) => !look.hidden));
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.position - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.position + 1));
      }
      show(position) {
        if (!this.looks.length) return;
        this.position = (position + this.looks.length) % this.looks.length;
        this.looks.forEach((look, index) => { look.hidden = index !== this.position; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latitude-purchase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('latitude-purchase')) {
    customElements.define('latitude-purchase', class extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        this.input = this.querySelector('input[name="id"]');
        this.select.addEventListener('change', () => {
          this.update(this.select.selectedOptions[0]);
          const variantId = this.select.value;
          const mainPicker = document.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
          const mainOption = [...(mainPicker?.querySelectorAll('input[data-variant-id]') || [])].find(input => input.dataset.variantId === variantId);
          if (mainOption && !mainOption.checked) mainOption.click();
        });
        this.onMainChange = event => {
          const picker = event.target.closest?.('variant-picker');
          if (!picker || picker.dataset.productId !== this.dataset.productId) return;
          const id = event.target.dataset.variantId;
          const option = [...this.select.options].find(item => item.value === id);
          if (option) { this.select.value = id; this.update(option); }
        };
        document.addEventListener('change', this.onMainChange);
      }
      disconnectedCallback() { document.removeEventListener('change', this.onMainChange); }
      update(option) {
        this.input.value = option.value;
        this.querySelector('.latitude-purchase__price [data-price]').textContent = option.dataset.price;
        const compare = this.querySelector('.latitude-purchase__price [data-compare-price]');
        compare.textContent = option.dataset.comparePrice || '';
        compare.hidden = !option.dataset.comparePrice;
        this.querySelector('button[type="submit"]').disabled = option.disabled;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latitude-upgrade-purchase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('latitude-upgrade-purchase')) {
    customElements.define('latitude-upgrade-purchase', class extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        this.input = this.querySelector('input[name="id"]');
        this.select?.addEventListener('change', () => {
          this.update(this.select.selectedOptions[0]);
          const variantId = this.select.value;
          const mainPicker = document.querySelector(`latitude-upgrade-options[data-product-id="${this.dataset.productId}"]`);
          mainPicker?.selectVariant(variantId);
        });
        this.onMainChange = event => {
          const picker = event.target.closest?.('variant-picker');
          if (!this.select || !picker || picker.dataset.productId !== this.dataset.productId) return;
          const id = event.target.dataset.variantId;
          const option = [...this.select.options].find(item => item.value === id);
          if (option) { this.select.value = id; this.update(option); }
        };
        document.addEventListener('change', this.onMainChange);
      }
      disconnectedCallback() { document.removeEventListener('change', this.onMainChange); }
      update(option) {
        this.input.value = option.value;
        this.querySelector('.latitude-upgrade-purchase__price [data-price]').textContent = option.dataset.price;
        const compare = this.querySelector('.latitude-upgrade-purchase__price [data-compare-price]');
        compare.textContent = option.dataset.comparePrice || '';
        compare.hidden = !option.dataset.comparePrice;
        this.querySelector('button[type="submit"]').disabled = option.disabled;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
